import Api from "../../utils/axios";

export const DeliveryApi = {
    createDeliveryFee: (payload) => Api.post("/master/create-delivery-fee", payload),
    updateDeliveryFee: (payload, id) => Api.put(`/master/update-delivery-fee/${id}`, payload),
    getDeliveryFeeById: (id) => Api.get(`master/get-delivery-fee-by-id/${id}`),
    getAllDeliveryFee: (payload,search="") => Api.post(`/master/get-all-delivery-fee-with-pagination?search=${search}`,payload),
    getAllDeliveryFeeData: () => Api.get(`/master/get-all-delivery-fee`),
    deleteDeliveryFee: (id) => Api.delete(`master/delete-delivery-fee/${id}`)
};

